import React, {Component} from 'react';

export default class WhatIs extends Component {

    constructor(props) {
        super(props);

    }

    render() {
        return (
            // <div className="row" data-aos="fade-up" data-aos-duration="100">
            <div className="row">
                <div className="col-lg-12">
                    <h6 className="title">¿Qué es Adopta un Animal?</h6>
                    <p>
                        <span className="init-description" >Adopta un </span>
                        <span className="colored-logo ">animal </span>
                        es una plataforma donde puedes encontrar al perro o gato que quieres adoptar. Utiliza los filtros
                        y Adopta un Animal lo buscará por ti. ¡Así de simple! y totalmente gratis.
                    </p>

                </div>
            </div>
        );
    }

}